import React from "react";
import { Icon } from "@vitalsource/vstui";

class WhatsNew extends React.PureComponent {
  render() {
    return (
      <Icon {...this.props} height={72} width={72}>
        <path
          d="M47.7298 53.1602C48.9013 51.3902 49.6752 49.4302 49.6967 47.3002C49.7289 44.8702 48.7939 42.2102 49.8901 40.0902C50.4813 38.9502 51.5991 38.0902 52.7921 37.3402C55.1781 35.8402 57.9296 34.7002 60.1974 33.0902C64.4965 30.0402 65.4316 24.4802 63.5185 19.5302C61.6053 14.5702 54.2108 9.9502 47.934 9.9502C44.0111 9.9502 40.9157 11.6202 37.4226 12.4402C33.0912 13.4502 28.5664 12.0702 23.9555 11.8602C17.0984 11.5502 11.1656 14.2902 7.1566 18.0902C2.79297 22.2302 0.34245 27.7102 0.525164 33.5702C0.890592 44.8402 10.6067 54.9602 24.6434 59.2102C29.5767 60.7002 34.9506 61.1802 39.282 59.7802C42.3989 58.7702 44.7849 56.8602 46.6013 54.6802C47.0097 54.1902 47.3859 53.6902 47.7298 53.1602Z"
          fill="#F0F2F7"
        />
        <path
          d="M14.9398 50.5098L8.73828 56.2698"
          stroke="#8FA1D2"
          strokeWidth="2"
          strokeMiterLimit="10"
          strokeLinecap="round"
        />
        <path
          d="M63.3251 15.4004L56.1133 20.0204"
          stroke="#8FA1D2"
          strokeWidth="2"
          strokeMiterLimit="10"
          strokeLinecap="round"
        />
        <path
          d="M39.5078 55L42.0121 62.81"
          stroke="#8FA1D2"
          strokeWidth="2"
          strokeMiterLimit="10"
          strokeLinecap="round"
        />
        <path
          d="M29.7274 21.5501L5.55546 10.6001C5.02882 10.3601 4.49142 10.8901 4.77087 11.3701L15.9164 30.2201C16.0454 30.4301 16.0024 30.6901 15.8304 30.8701L1.23482 45.3101C0.86939 45.6801 1.17033 46.2801 1.70772 46.2501L19.2268 45.3201C19.5384 45.3001 19.8071 45.5101 19.8501 45.7901L22.7951 63.7201C22.8703 64.2001 23.5367 64.3601 23.8591 63.9801L35.9397 49.5401C36.0794 49.3701 36.3266 49.2901 36.5523 49.3401L60.1332 54.5601C60.6168 54.6701 61.0145 54.2101 60.821 53.7901L53.4587 38.4601C53.319 38.1701 53.4587 37.8401 53.7704 37.7201L70.5586 31.1701C71.0745 30.9701 71.0423 30.2801 70.5049 30.1301L51.1587 24.3701C50.9437 24.3101 50.7933 24.1401 50.7503 23.9401L47.5152 7.46006C47.4292 7.02006 46.8595 6.85006 46.5156 7.16006L30.3938 21.4601C30.2111 21.6201 29.9424 21.6601 29.7167 21.5601L29.7274 21.5501Z"
          stroke="#425B9F"
          strokeWidth="2"
          strokeMiterLimit="10"
          strokeLinecap="round"
        />
        <path
          d="M31.7387 28.0403L21.3562 23.2903C20.8296 23.0503 20.2814 23.5703 20.5609 24.0503L25.2792 32.1303C25.3974 32.3403 25.3652 32.5903 25.1932 32.7703L18.9379 39.0303C18.5725 39.3903 18.8735 39.9803 19.4108 39.9503L26.6657 39.5603C26.9774 39.5403 27.246 39.7502 27.289 40.0303L28.5358 47.6903C28.611 48.1702 29.2881 48.3302 29.5998 47.9403L34.7481 41.7103C34.8878 41.5403 35.135 41.4603 35.3607 41.5103L45.7216 43.8303C46.2053 43.9403 46.6137 43.4903 46.4095 43.0703L43.2926 36.5003C43.1636 36.2203 43.2926 35.8903 43.6043 35.7703L50.5259 33.0403C51.0311 32.8403 50.9988 32.1703 50.4722 32.0103L42.2608 29.5403C42.0566 29.4803 41.8954 29.3103 41.8524 29.1103L40.4552 21.9103C40.3692 21.4703 39.7888 21.3003 39.4449 21.6103L32.3943 27.9403C32.2116 28.1003 31.9429 28.1403 31.7064 28.0403H31.7387Z"
          fill="#75CDEA"
        />
      </Icon>
    );
  }
}

WhatsNew.displayName = "WhatsNew";
WhatsNew.vstuiName = "Icon";

export default WhatsNew;
